import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { useBoolean, useNumber, useString, useWindowSize } from "helpers/hooks"
import { useAppSelector } from "hooks/useApp"
import { cloneDeep, compact, isUndefined, toArray } from "lodash"
import { GetUsersInProjectProp } from "pages/project-component/types"
import { useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"
import { closeModal, openModal } from "reducers/modal"
import { configureStore } from "stores/configureStore"
import { STATUS_RESPONSE } from "types"
import PageLayout from "../layout/PageLayout"
import NoData from "./molecules/NoData"
import FormModalActionProjectCard from "./organisms/FormModalActionProjectCard"
import FormProject from "./organisms/FormProject"
import HeaderProject from "./organisms/HeaderProject"
import ProjectCard from "./organisms/ProjectCard"
import { LIST_STATUS_PROJECT, TAB_PROJECT } from "./project.constant"
import {
  archiveProjectMiddleware,
  deleteProjectAttachment,
  favoriteProjectMiddleware,
  getCategoriesMiddleware,
  getProjectCountMiddleware,
  getProjectsMiddleware,
  validateAccessTokenMiddleware,
} from "./services/api"
import {
  CategoryDetail,
  defaultCategoryDetail,
  defaultProjectDetail,
  ParamsProjectsProps,
  ProjectCount,
  ProjectDetail,
} from "./types"
import { customLocalStorageHandler } from "helpers/utils"
import { NAME_LOCALSTORAGE } from "constants/localStorage"
import { pushTo, useQuery } from "helpers/history"
import Button from "components/Button/Button"
import { ButtonScroll } from "components/Button/ButtonScroll"
import { MoveToOrganizationModal } from "./modal/MoveToOrganizationModal"
import { hasPermission } from "helpers/permissions"
import { PERMISSIONS } from "constants/permissions"
import { PATH } from "constants/path"
import { getShareKeyProjectMiddleware } from "pages/project-share-organization/project-share-organization.api"
import { ReactComponent as IconMessagerDeleteComponent } from "assets/images/icons/icon-messager-delete-component.svg"
import { GroupsOrganizationResponse } from "pages/groups/groups.type"
import { getGroupsOrganizationMiddleware } from "pages/groups/groups.api"
interface Props {
  orginGroupId?: string
  callGroupsOrganizationDetail?: () => void
}
const Projects = (props: Props) => {
  const { isMobile } = useWindowSize()
  const { orginGroupId, callGroupsOrganizationDetail } = props
  const { storageData, handleSetLocalStorage } = customLocalStorageHandler(
    NAME_LOCALSTORAGE.PROJECT
  )
  // const { acceptedSharingProject } = useShareInvitation()

  const query = useQuery()
  const sharedProject = JSON.parse(
    localStorage.getItem("sharedProject") || "{}"
  )
  const accessToken = query.get("access_token") || sharedProject.accessToken
  //validate accessToken later
  // const projectId = query.get("project") || sharedProject.projectId
  // const conversationId =
  //   query.get("conversation_id") || sharedProject.conversation_id

  const userInfo = useAppSelector((state) => state.userInfo)
  const dataStorageProject: {
    category: string
    status: { id: string; label: string; name: string; value: string }[]
    isDeleted: boolean
    isArchived: boolean
    tabMenu: TAB_PROJECT
    sharing: number
  } = !isUndefined(storageData)
    ? storageData
    : {
        category: "",
        status: [{ id: "", label: "All", name: "All", value: "0" }],
        isDeleted: false,
        isArchived: true,
        tabMenu: "my_project",
        sharing: -1,
      }

  /// handle loading to show data when scrolling
  const isLoading = useBoolean()
  const isLoadingMore = useBoolean()

  const [arrProject, setArrProject] = useState<ProjectDetail[]>([])
  const pageHook = useNumber(1)
  const rowsPerPageHook = useNumber(24)
  const [projectDetail, setProjectDetail] =
    useState<ProjectDetail>(defaultProjectDetail)
  const [categories, setCategories] = useState<CategoryDetail[]>([])
  const [scrollDirection, setScrollDirection] = useState<"top" | "bottom">(
    "bottom"
  )
  const isAssignToGroup = useBoolean(false)
  const [groups, setGroups] = useState<GroupsOrganizationResponse[]>([])
  // const getProjectDetail = async (projectId: string) => {
  //   try {
  //     const dataProjectDetailRes = await getProjectDetailMiddleware(
  //       projectId,
  //       undefined,
  //       false
  //     )

  //     acceptedSharingProject(dataProjectDetailRes, true)
  //   } catch (error) {}
  // }
  //
  // useEffect(() => {
  //   if (userInfo.id && projectId && !conversationId) {
  //     getProjectDetail(projectId)
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [projectId, userInfo.id])

  //
  // const getConversation = async (conversationId: string) => {
  //   if (conversationId) {
  //     const conversationInfo = await getConversationKeyMiddleware(
  //       conversationId
  //     )
  //     // if user is not accepted -> display modal
  //     if (!conversationInfo.accepted) {
  //       await acceptedSharingConversationMiddleware(conversationId)
  //       localStorage.removeItem("sharedProject")
  //     }
  //     const conversationLocalData = JSON.parse(
  //       localStorage.getItem("conversations") || "{}"
  //     )
  //     // redirect conversation
  //     if (conversationInfo.role !== "invitee") {
  //       localStorage.setItem(
  //         "conversations",
  //         JSON.stringify({
  //           ...conversationLocalData,
  //           tab: "Cc to me",
  //           conversationId,
  //         })
  //       )
  //       pushTo(PATH.conversations, undefined, undefined, {
  //         conversationId: conversationId,
  //         tab: "cc-to-me",
  //       })
  //     } else {
  //       localStorage.setItem(
  //         "conversations",
  //         JSON.stringify({
  //           ...conversationLocalData,
  //           tab: "To me",
  //           conversationId,
  //         })
  //       )
  //       pushTo(PATH.conversations, undefined, undefined, {
  //         conversationId: conversationId,
  //         tab: "to-me",
  //       })
  //     }
  //     //
  //   }
  // }
  // useEffect(() => {
  //   if (userInfo.id && conversationId) {
  //     if (sharedProject?.user_id && sharedProject.user_id !== userInfo.id) {
  //       return
  //     }
  //     getConversation(conversationId)
  //   }
  // }, [conversationId, userInfo.id, sharedProject.user_id])
  //
  const validateAccessToken = async (token: string) => {
    const isValidAccessToken = await validateAccessTokenMiddleware(token)
    if (!isValidAccessToken) {
      toast(
        <LabelNotificationPage
          messenger={"Access token is invalid or expired!"}
          type={"error"}
        />
      )
    }
  }
  useEffect(() => {
    if (accessToken) validateAccessToken(accessToken)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken])

  /// for project card
  const isArchive = useBoolean(false)
  const isShare = useBoolean(false)
  const isSyncToOrganization = useBoolean(false)
  const isMoveToOrganization = useBoolean(false)
  ///

  /// for project filter
  const [applyFilter, setApplyFilter] = useState<boolean>(false)

  const selectSharing = useNumber(dataStorageProject?.sharing ?? -1)
  const search = useString()
  const showArchive = useBoolean(dataStorageProject.isArchived)
  const showDeletedAttachment = useBoolean(dataStorageProject.isDeleted)
  const [selectStatusProject, setSelectStatusProject] = useState<any>(
    dataStorageProject?.status && !Array.isArray(dataStorageProject.status)
      ? dataStorageProject.status
      : { 0: Number(LIST_STATUS_PROJECT[0].value) }
  )
  const [selectedGroupProject, setSelectedGroupProject] = useState<any>({
    "-1": "-1",
  })

  // const [selectCategory, setSelectCategory] = useState<CategoryDetail>(
  //   dataStorageProject?.category
  //     ? (dataStorageProject.category)
  //     : defaultCategoryDetail
  // )
  const selectCategoryId = useString(dataStorageProject?.category || "")
  const [tabProject, setTabProject] = useState<TAB_PROJECT>(
    dataStorageProject?.tabMenu
      ? dataStorageProject.tabMenu
      : TAB_PROJECT.MY_PROJECT
  )
  ///

  const isMoreData = useBoolean(false)
  const isOpenFormDialog = useBoolean(false)
  const [projectCount, setProjectCount] = useState<ProjectCount>({
    my_projects: 0,
    shared_with_me_projects: 0,
    favorite_projects: 0,
  })
  const isReadShareProject = useBoolean(false)
  const ref = useRef<HTMLDivElement>(null)

  /// using firstLoading to prevent api called double
  const firstLoading = useBoolean(true)
  const callAPI = useBoolean(false)
  const showIconScroll = useBoolean(false)
  const warningShareKey = useString("")

  useEffect(() => {
    if (!userInfo?.id || orginGroupId) {
      return
    }
    if (!userInfo.last_organization_id) {
      warningShareKey.setValue("")
      return
    }
    const isFullAccess = hasPermission(
      userInfo,
      PERMISSIONS.PROJECT_FULL_ACCESS
    )
    if (!isFullAccess) {
      warningShareKey.setValue("")
      return
    }
    getShareKeyProjectData()
  }, [userInfo?.id, orginGroupId])

  const getShareKeyProjectData = async () => {
    try {
      const response = await getShareKeyProjectMiddleware()

      if (response) {
        const usersNeedingKeys = response.users.filter(
          (user) => user.projectKeyIdTotal < response.totalProjectKeys
        )
        if (usersNeedingKeys.length > 0) {
          warningShareKey.setValue(
            `You’ve shared project keys with ${
              response.totalUsers - usersNeedingKeys.length
            } of ${response.totalUsers} members so far (${Math.round(
              ((response.totalUsers - usersNeedingKeys.length) /
                response.totalUsers) *
                100
            )}% done). `
          )
        } else {
          warningShareKey.setValue("")
        }
      }
    } catch (error) {
      warningShareKey.setValue("")
    }
  }

  useEffect(() => {
    if (!firstLoading.value && !callAPI.value) {
      return
    }
    if (!userInfo?.id) {
      return
    }
    if (!hasPermission(userInfo, PERMISSIONS.PROJECT_VIEW)) {
      pushTo(PATH.workspaceSetting)
      return
    }

    firstLoading.setValue(false)

    // get project info
    getProjects()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [callAPI.value, userInfo?.id])

  useEffect(() => {
    if (!userInfo.id) {
      return
    }
    isReadShareProject.setValue(Boolean(userInfo.has_new_shared_project))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.id])

  useEffect(() => {
    if (!userInfo?.id) {
      return
    }
    if (!userInfo.last_organization_id) {
      return
    }
    getGroups()
  }, [userInfo?.id, orginGroupId])

  /// because api called based on multi dependencies
  /// this func used one state to call api
  const handleCallAPI = () => {
    callAPI.setValue(true)

    /// set state value back to default value for using it next time
    setTimeout(() => {
      callAPI.setValue(false)
    }, 50)
  }

  const getProjects = async () => {
    const params = changeProjectParams(1)

    const url = urlTabProjectAndCategory(tabProject)
    isLoading.setValue(true)

    try {
      const dataRes = await getProjectsMiddleware(params, url.urlProject)
      await getProjectCount()
      await getCategories(url.urlCategory)
      await getGroups()
      setArrProject(dataRes)

      isLoading.setValue(false)

      isMoreData.setValue(dataRes.length < rowsPerPageHook.value ? false : true)

      if (tabProject === TAB_PROJECT.SHARED) {
        isReadShareProject.setValue(false)
      }

      const newStorageData = {
        category: selectCategoryId.value,
        status: selectStatusProject,
        isDeleted: showDeletedAttachment.value,
        isArchived: showArchive.value,
        tabMenu: tabProject,
        sharing: selectSharing.value,
        group: selectedGroupProject,
      }
      if (!orginGroupId) {
        handleSetLocalStorage(newStorageData)
      }
    } catch (error) {
      isLoading.setValue(false)
    }
  }

  const getGroups = async () => {
    const dataRes = await getGroupsOrganizationMiddleware({
      page: 1,
      pageSize: 1,
      is_full: true,
      search: "",
    })
    setGroups(dataRes.data)
  }

  const getCategories = async (newURL: string) => {
    try {
      const dataRes = await getCategoriesMiddleware(newURL)
      const newDataRes: CategoryDetail[] = dataRes.map((el) => {
        return {
          ...el,
          label: el.name,
          value: el.id,
        }
      })
      newDataRes.unshift(defaultCategoryDetail)
      setCategories(newDataRes)
    } catch (error) {
      setCategories([])
    }
  }

  const getProjectCount = async () => {
    try {
      const dataRes = await getProjectCountMiddleware(orginGroupId)
      if (dataRes) {
        setProjectCount({
          favorite_projects: dataRes.favorite_projects,
          my_projects: dataRes.my_projects,
          shared_with_me_projects: dataRes.shared_with_me_projects,
        })
      }
    } catch (error) {
      setProjectCount({
        favorite_projects: 0,
        my_projects: 0,
        shared_with_me_projects: 0,
      })
    }
  }
  const urlTabProjectAndCategory = (tab: TAB_PROJECT) => {
    let newURLProject = "get-list"
    let newURLCategory = "my-projects"
    switch (tab) {
      case TAB_PROJECT.FAVORITE:
        newURLProject = "get-list-favorite"
        newURLCategory = "favorite-projects"
        break
      case TAB_PROJECT.SHARED:
        newURLProject = "get-shared-with-me"
        newURLCategory = "projects-shared-with-me"

        break
    }
    return {
      urlProject: `/api/project/${newURLProject}`,
      urlCategory: `/api/category/get-list/${newURLCategory}`,
    }
  }

  const handleChangeButton = (
    key:
      | "share"
      | "edit"
      | "archive"
      | "favorite"
      | "delete_attachment"
      | "sync_to_organization"
      | "move_to_organization"
      | "add_to_group"
      | "unassign_from_group",
    data: ProjectDetail,
    callback: () => void
  ) => {
    setProjectDetail(data)
    switch (key) {
      case "share":
        isShare.setValue(true)
        break
      case "edit":
        isOpenFormDialog.setValue(true)
        break
      case "archive":
        isArchive.setValue(true)
        break
      case "favorite":
        callAPIFavorte(data)
        break
      case "delete_attachment":
        configureStore.dispatch(
          openModal({
            type: "Delete",
            props: {
              deleteModal: {
                title: `When action is confirmed, all attachment files also be removed. This action cannot be undone.`,
                label: `Warning`,
                content: `Press "Delete" to process`,
                onSubmit: onSubmitDeleteAttachment(data),
                styleTitle: { textAlign: "center" },
                titleButton: "Delete",
              },
            },
          })
        )
        break
      case "sync_to_organization":
        isSyncToOrganization.setValue(true)
        break
      case "move_to_organization":
        isMoveToOrganization.setValue(true)
        break
      case "add_to_group":
        isAssignToGroup.setValue(true)
        break
      case "unassign_from_group":
        // configureStore.dispatch(
        //   openModal({
        //     type: "Delete",
        //     props: {
        //       deleteModal: {
        //         title: `This action will unassign the project from its current group. The project will no longer be associated with any group, and group-specific permissions or settings will no longer apply.`,
        //         label: `Unassign Project from Group`,
        //         content: `This action cannot be undone.`,
        //         onSubmit: handleUnassignFromGroup(data),
        //         styleTitle: { textAlign: "center" },
        //         titleButton: "Unassign Project",
        //       },
        //     },
        //   })
        // )
        break
    }
    callback()
  }

  const onSubmitDeleteAttachment = (data: ProjectDetail) => () => {
    deleteProjectAttachment(data.id)
      .then(() => {
        toast(
          <LabelNotificationPage
            messenger={"Delete project successfully!"}
            type="success"
          />
        )
        getProjects()
        if (orginGroupId) {
          callGroupsOrganizationDetail?.()
        }
        closeModal()
      })
      .catch((error) => {
        toast(
          <LabelNotificationPage
            messenger={
              error.response?.data?.message || "Delete project failed!"
            }
            type="error"
          />
        )
        closeModal()
      })
  }

  const onArchiveProject = () => {
    if (!projectDetail?.id) {
      return
    }

    isLoading.setValue(true)

    archiveProjectMiddleware(
      projectDetail.id,
      projectDetail.is_archived,
      (type: STATUS_RESPONSE, messenger: string) => {
        if (type === STATUS_RESPONSE.SUCCESS) {
          isArchive.setValue(false)
          if (pageHook.value !== 1) {
            pageHook.setValue(1)
            return
          }
          getProjects()
        }
        toast(<LabelNotificationPage messenger={messenger} type={type} />)

        isLoading.setValue(false)
      },
      projectDetail.name
    )
  }

  const callAPIFavorte = (data: ProjectDetail) => {
    if (!data.id) {
      return
    }

    isLoading.setValue(true)

    favoriteProjectMiddleware(
      data.id,
      data.name,
      Boolean(data.is_favorite),
      (
        type: STATUS_RESPONSE,
        messenger: string,
        newProject?: ProjectDetail
      ) => {
        if (type === STATUS_RESPONSE.SUCCESS && newProject) {
          const newData = cloneDeep(arrProject)
          const index = newData.findIndex((el) => el.id === data.id)
          newData[index].is_favorite = newProject.is_favorite
          if (tabProject === TAB_PROJECT.FAVORITE) {
            newData.splice(index, 1)
          }
          setArrProject(newData)
          getProjectCount()
        } else {
          toast(<LabelNotificationPage messenger={messenger} type={type} />)
        }

        isLoading.setValue(false)
      }
    )
  }

  const onChangeTab = (newTab: TAB_PROJECT) => () => {
    if (newTab === tabProject) {
      return
    }
    pageHook.setValue(1)
    handleCallAPI()
    selectCategoryId.setValue("")
    setTabProject(newTab)
    if (newTab === TAB_PROJECT.SHARED) {
      isReadShareProject.setValue(false)
    }
    showIconScroll.setValue(false)
  }

  const onChangeShowArchive = () => {
    pageHook.setValue(1)
    showArchive.setValue(!showArchive.value)
    if (!showArchive.value && showDeletedAttachment.value) {
      selectSharing.setValue(-1)
      setSelectStatusProject({ 0: Number(LIST_STATUS_PROJECT[0].value) })
      selectCategoryId.setValue("")
    }
    showDeletedAttachment.setValue(false)
  }

  const onChangeShowDeleteAttachment = () => {
    pageHook.setValue(1)
    if (!showDeletedAttachment.value) {
      showArchive.setValue(false)
      selectSharing.setValue(-2)
      setSelectStatusProject(-1)
      selectCategoryId.setValue("")
    } else {
      showArchive.setValue(true)
      selectSharing.setValue(-1)
      setSelectStatusProject({ 0: Number(LIST_STATUS_PROJECT[0].value) })
      selectCategoryId.setValue("")
    }
    showDeletedAttachment.setValue(!showDeletedAttachment.value)
  }

  const onChangeSelected = (
    key: "status" | "category" | "sharing" | "group",
    selected: any
  ) => {
    pageHook.setValue(1)
    switch (key) {
      case "status":
        setSelectStatusProject((prev) => {
          if (
            (prev[0] === undefined && selected[0] === 0) ||
            Object.keys(selected).length === 0
          ) {
            return { 0: 0 }
          }
          if (selected[0] === 0 && Object.keys(selected).length > 1) {
            delete selected[0]
          }

          return selected
        })
        break
      case "group":
        setSelectedGroupProject((prev) => {
          if (
            (prev["-1"] === undefined && selected["-1"] === "-1") ||
            Object.keys(selected).length === 0
          ) {
            return { "-1": "-1" }
          }
          if (selected["-1"] === "-1" && Object.keys(selected).length > 1) {
            delete selected["-1"]
          }

          return selected
        })
        break

      case "sharing":
        selectSharing.setValue(selected.value)
        break

      default:
        selectCategoryId.setValue(selected)

        // if (!isMobile) {
        //   handleCallAPI()
        // }
        break
    }
  }

  const onCloseModal = () => {
    isOpenFormDialog.setValue(false)
  }
  const onClickNewProject = () => {
    isOpenFormDialog.setValue(true)
    setProjectDetail(defaultProjectDetail)
  }
  const handleChangeData = () => {
    pageHook.setValue(1)
    getProjects()
    if (orginGroupId) {
      callGroupsOrganizationDetail?.()
    }
  }

  const changeProjectParams = (defaultPage?: number) => {
    const status = compact(toArray(selectStatusProject))
    const groupIds = compact(
      toArray(selectedGroupProject).filter((el) => el !== "-1")
    )
    const newParams: ParamsProjectsProps = {
      page: defaultPage ?? pageHook.value + 1,
      pageSize: rowsPerPageHook.value,
      category_ids: JSON.stringify(
        selectCategoryId.value && selectCategoryId.value !== "-1"
          ? [selectCategoryId.value]
          : []
      ),
      status: JSON.stringify(status.length === 0 ? [0] : status),
      is_archived: showArchive.value ? 1 : 0,
      is_deleted: showDeletedAttachment.value ? 1 : 0,
      is_shared: selectSharing.value,
      search: search.value,
    }
    if (orginGroupId) {
      newParams.group_id = orginGroupId
    } else {
      newParams.group_ids = JSON.stringify(groupIds)
    }
    if (!selectCategoryId.value || !newParams.category_ids) {
      delete newParams.category_ids
    }
    if (!showArchive.value) {
      delete newParams.is_archived
    }
    if (selectSharing.value < -1) {
      delete newParams.is_shared
    }
    if (selectStatusProject.value < 0) {
      delete newParams.status
    }
    if (tabProject === TAB_PROJECT.SHARED) {
      delete newParams.is_shared
    }
    return newParams
  }

  const handleScroll = async () => {
    if (!ref.current) return
    const { scrollTop, scrollHeight, clientHeight } = ref.current
    const lengthScroll = 300
    if (scrollHeight - clientHeight > lengthScroll) {
      showIconScroll.setValue(true)
    } else {
      showIconScroll.setValue(false)
    }
    if (scrollTop === 0) {
      setScrollDirection("bottom")
    } else if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
      setScrollDirection("top")
    }
  }
  const handleLoadMore = async () => {
    if (isLoadingMore.value) {
      return
    }
    isLoadingMore.setValue(true)
    try {
      const params = changeProjectParams()
      const url = urlTabProjectAndCategory(tabProject)
      const dataRes = await getProjectsMiddleware(params, url.urlProject)
      isMoreData.setValue(dataRes.length < rowsPerPageHook.value ? false : true)
      pageHook.setValue(pageHook.value + 1)
      const newData = cloneDeep(arrProject).concat(dataRes)
      setArrProject(newData)
      isLoadingMore.setValue(false)
    } catch (error) {
      isLoadingMore.setValue(false)
    }
  }

  const contentNoDataTabProject = (tab: TAB_PROJECT) => {
    let newContent =
      // !Number(selectStatusProject.id) && !selectCategory.id
      !projectCount.my_projects &&
      tabProject &&
      tabProject === TAB_PROJECT.MY_PROJECT
        ? "You have not created any Project!"
        : "No projects found."
    switch (tab) {
      case TAB_PROJECT.FAVORITE:
      case TAB_PROJECT.SHARED:
        newContent = "No projects found!"
        break
    }
    return newContent
  }
  const onCloseFormShare =
    (newUserRole: GetUsersInProjectProp[], projectId: string) => () => {
      isShare.setValue(false)
      const newProjects = cloneDeep(arrProject)
      const index = newProjects.findIndex((el) => el.id === projectId)
      if (index > -1) {
        newProjects[index].role_users = newUserRole
        setArrProject(newProjects)
      }
    }

  const renderBody = () => {
    if (!arrProject.length) {
      if (isLoading.value) {
        return null
      }

      return (
        <NoData
          onClick={onClickNewProject}
          context={contentNoDataTabProject(tabProject)}
          showButton={
            !projectCount.my_projects &&
            tabProject &&
            tabProject === TAB_PROJECT.MY_PROJECT
            // !Number(selectStatusProject.id) && !selectCategory.id
          }
        />
      )
    }

    return (
      <div className="grid grid-cols-auto-fill-min-310 gap-6 my-1 mr-6">
        {arrProject.map((el, index) => {
          return (
            <ProjectCard
              isDiable={false}
              key={index}
              item={el}
              handleChangeButton={handleChangeButton}
              loggedUserId={userInfo.id}
              isSyncToOrganization={
                userInfo.last_organization_id
                  ? hasPermission(
                      userInfo,
                      PERMISSIONS.SYNC_COMMIT_COMPONENT_ADD
                    ) && !isMobile
                  : true
              }
              isMoveToOrganization={
                userInfo.last_organization_id ? false : true
              }
              isCheckPermissionOrganization={
                userInfo.last_organization_id
                  ? hasPermission(userInfo, PERMISSIONS.PROJECT_EDIT)
                  : true
              }
              isAddToGroup={
                userInfo.last_organization_id
                  ? hasPermission(userInfo, PERMISSIONS.GROUP_ORGANIZATION_ADD)
                  : true
              }
              isOrganization={userInfo.last_organization_id ? true : false}
            />
          )
        })}
      </div>
    )
  }
  const handleClickScroll = () => {
    if (!ref.current) return

    if (scrollDirection === "bottom") {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
        behavior: "smooth",
      })
    } else {
      ref.current.scrollTo({
        top: 0,
        behavior: "smooth",
      })
    }
  }

  const renderContent = () => {
    return (
      <>
        <div className="pl-6 h-full pt-6 pb-5 relative ">
          <div
            className="h-full overflow-auto"
            ref={ref}
            onScroll={handleScroll}
          >
            {renderBody()}
            {isMoreData.value ? (
              <div className="flex justify-center mt-4">
                <Button
                  title="Load more"
                  colorBtn="white"
                  onClick={handleLoadMore}
                  disabled={isLoadingMore.value}
                  isDisabledBtn
                />
              </div>
            ) : null}
          </div>
          {showIconScroll.value && (
            <ButtonScroll
              scrollDirection={scrollDirection}
              handleClickScroll={handleClickScroll}
            />
          )}
        </div>

        {isOpenFormDialog.value && (
          <FormProject
            openModal={isOpenFormDialog.value}
            handleChangeData={handleChangeData}
            defaultRequest={{
              id: projectDetail.id,
              name: projectDetail.name,
              description: projectDetail.description,
              selectCategories: projectDetail.categories.length
                ? projectDetail.categories.map((el) => {
                    return {
                      id: el.id,
                      name: el.name,
                      label: el.name,
                      value: el.id,
                    }
                  })
                : [],
            }}
            onCloseModal={onCloseModal}
            groups={
              orginGroupId
                ? groups.filter((el) => el.id === orginGroupId)
                : groups
            }
            isDisableGroup={orginGroupId ? true : false}
          />
        )}
        <FormModalActionProjectCard
          isArchive={isArchive}
          isShare={isShare}
          isLoading={isLoading}
          projectDetail={projectDetail}
          onArchiveProject={onArchiveProject}
          onCloseFormShare={onCloseFormShare}
        />
        {isMoveToOrganization.value ? (
          <MoveToOrganizationModal
            isOpen={isMoveToOrganization.value}
            onClose={() => isMoveToOrganization.setValue(false)}
            projectId={projectDetail.id}
            projectName={projectDetail.name}
            callback={handleChangeData}
          />
        ) : null}
      </>
    )
  }
  if (orginGroupId) {
    return (
      <div className="h-full flex flex-col justify-between overflow-hidden">
        <div className="bg-[#FFFFFF] border-b border-[#E4E4E4] min-h-[63px]">
          <HeaderProject
            tab={tabProject}
            onChangeTab={onChangeTab}
            showArchive={showArchive}
            showDeletedAttachment={showDeletedAttachment}
            selectedStatusProject={selectStatusProject}
            selectedGroupProject={selectedGroupProject}
            setSelectStatusProject={setSelectStatusProject}
            setSelectedGroupProject={setSelectedGroupProject}
            selectSharing={selectSharing}
            onChangeShowArchive={onChangeShowArchive}
            onChangeShowDeleteAttachment={onChangeShowDeleteAttachment}
            arrCategory={categories}
            selectCategoryId={selectCategoryId}
            // selectedCategory={selectCategory}
            onChangeSelected={onChangeSelected}
            onClickNewProject={onClickNewProject}
            projectCount={projectCount}
            isReadShareProject={isReadShareProject.value}
            setApplyFilter={setApplyFilter}
            applyFilter={applyFilter}
            handleCallAPI={handleCallAPI}
            search={search}
            isGroup={true}
            groups={[]}
            // setSelectCategory={setSelectCategory}
          />
        </div>
        <div className="flex-1 overflow-auto">{renderContent()}</div>
      </div>
    )
  }
  return (
    <PageLayout
      contentClass="max-sm-project-content"
      childrenHeader={
        <HeaderProject
          tab={tabProject}
          onChangeTab={onChangeTab}
          showArchive={showArchive}
          showDeletedAttachment={showDeletedAttachment}
          selectedStatusProject={selectStatusProject}
          selectedGroupProject={selectedGroupProject}
          setSelectStatusProject={setSelectStatusProject}
          setSelectedGroupProject={setSelectedGroupProject}
          selectSharing={selectSharing}
          onChangeShowArchive={onChangeShowArchive}
          onChangeShowDeleteAttachment={onChangeShowDeleteAttachment}
          arrCategory={categories}
          selectCategoryId={selectCategoryId}
          // selectedCategory={selectCategory}
          onChangeSelected={onChangeSelected}
          onClickNewProject={onClickNewProject}
          projectCount={projectCount}
          isReadShareProject={isReadShareProject.value}
          setApplyFilter={setApplyFilter}
          applyFilter={applyFilter}
          handleCallAPI={handleCallAPI}
          search={search}
          groups={groups}

          // setSelectCategory={setSelectCategory}
        />
      }
      childrenWarning={
        warningShareKey.value ? (
          <div className="flex items-center justify-center bg-[#F7F7F7] px-[24px]">
            <div
              className="flex items-center p-2 w-full mt-[8px]"
              style={{
                minHeight: 38,
                background: "rgba(232, 122, 22, 0.20)",
                borderRadius: 6,
              }}
            >
              <IconMessagerDeleteComponent
                style={{
                  minWidth: 20,
                }}
                className="icon-warning-messager"
              />
              <p
                className="font-semibold text-13 leading-22  pl-1"
                style={{
                  color: "#E87A16",
                }}
              >
                {warningShareKey.value}
                <span
                  className="underline cursor-pointer"
                  onClick={() => {
                    pushTo(PATH.shareKeyOrganization)
                  }}
                >
                  [Share with more →]
                </span>
              </p>
            </div>
          </div>
        ) : undefined
      }
      minWidth="min-w-[1280px]"
    >
      {renderContent()}
    </PageLayout>
  )
}
export default Projects
